// Reconstructed from assets/theme-contact-us-1f704519.js (the prior source
// went missing on disk; only the compiled bundle was in the repo). Behaviour
// matches the live handler with one addition: `lead_source` is read from the
// form and required client-side. Phone is read but only included when filled.
const readUtm = () => {
  const out = {}
  try {
    const sp = new URLSearchParams(window.location.search)
    for (const k of [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
    ]) {
      const v = sp.get(k)
      if (v) out[k] = v.slice(0, 200)
    }
  } catch {}
  return out
}

const sha256Hex = async (input) => {
  const buf = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(input),
  )
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("")
}

const buildPayload = (form) => {
  const fd = new FormData(form)
  return {
    email: String(fd.get("email") || "")
      .trim()
      .toLowerCase(),
    first_name: String(fd.get("first_name") || "").trim(),
    last_name: String(fd.get("last_name") || "").trim(),
    phone: String(fd.get("phone") || "").trim(),
    lead_source: String(fd.get("lead_source") || "").trim(),
    message: String(fd.get("message") || "").trim(),
    source: "contact_form",
    page_url: fd.get("page_url") || window.location.href,
    honeypot: String(fd.get("website") || ""),
    ...readUtm(),
  }
}

const setMessage = (form, state, text) => {
  const el = form.querySelector("[data-contact-message]")
  if (!el) return
  el.hidden = false
  el.dataset.state = state
  el.textContent = text
  el.classList.remove(
    "contact-form__message--success",
    "contact-form__message--error",
  )
  el.classList.add(`contact-form__message--${state}`)
}

const setLoading = (form, loading) => {
  const btn = form.querySelector("[data-contact-submit]")
  if (!btn) return
  btn.disabled = loading
  btn.dataset.loading = loading ? "true" : "false"
  const idle = btn.querySelector("[data-label-idle]")
  const busy = btn.querySelector("[data-label-loading]")
  if (idle) idle.classList.toggle("hidden", loading)
  if (busy) busy.classList.toggle("hidden", !loading)
}

const readLabels = (form) => ({
  success: form.dataset.successMessage || "",
  error: form.dataset.errorMessage || "",
  invalidEmail: form.dataset.invalidEmailMessage || "",
  nameRequired: form.dataset.nameRequiredMessage || "",
  messageRequired: form.dataset.messageRequiredMessage || "",
  leadSourceRequired:
    form.dataset.leadSourceRequiredMessage ||
    "Please tell us where you heard about us.",
  unavailable: form.dataset.unavailableMessage || "",
})

export const initContactForm = (form) => {
  if (!form || form.dataset.contactInitialised === "true") return
  form.dataset.contactInitialised = "true"
  const endpoint = form.dataset.endpoint

  form.addEventListener("submit", async (ev) => {
    ev.preventDefault()
    const payload = buildPayload(form)
    const labels = readLabels(form)

    if (payload.honeypot) {
      setMessage(form, "success", labels.success)
      form.reset()
      return
    }
    if (!payload.first_name || !payload.last_name) {
      setMessage(form, "error", labels.nameRequired)
      return
    }
    if (
      !payload.email ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)
    ) {
      setMessage(form, "error", labels.invalidEmail)
      return
    }
    if (!payload.lead_source) {
      setMessage(form, "error", labels.leadSourceRequired)
      return
    }
    if (!payload.message) {
      setMessage(form, "error", labels.messageRequired)
      return
    }
    if (!endpoint) {
      setMessage(form, "error", labels.unavailable)
      return
    }

    setLoading(form, true)
    try {
      const messageHash = await sha256Hex(payload.message)
      const idemKey = await sha256Hex(
        `${payload.email}|contact|${messageHash}`,
      )
      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Idempotency-Key": idemKey,
        },
        body: JSON.stringify(payload),
      })
      if (!res.ok) {
        const body = await res.json().catch(() => ({}))
        setMessage(form, "error", body.error || labels.error)
        return
      }
      setMessage(form, "success", labels.success)
      form.reset()
      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: "contact_submit",
          source: payload.source,
        })
      }
    } catch (err) {
      console.error("[contact] submit failed", err)
      setMessage(form, "error", labels.error)
    } finally {
      setLoading(form, false)
    }
  })
}

export const bindContactForms = () => {
  document
    .querySelectorAll("form.contact-form[data-contact-form]")
    .forEach(initContactForm)
}
